export interface ThemeColors {
  bg: string;
  bgSecondary: string;
  text: string;
  textMuted: string;
  textSecondary: string;
  card: string;
  sectionBg: string;
  sectionBorder: string;
  cardHover: string;
  cardBorder: string;
  bgAccent: string;
  buttonPrimary: string;
  buttonPrimaryText: string;
  buttonSecondary: string;
  buttonSecondaryText: string;
  inputBg: string;
  inputText: string;
  inputPlaceholder: string;
  selectOption: string;
  border: string;
  borderSubtle: string;
  errorBg: string;
  errorText: string;
  accentBg: string;
  accentText: string;
  iconBg: string;
  iconText: string;
  badge: string;
  // Legacy tokens for backward compatibility
  badgePending: string;
}

const DARK_THEME: ThemeColors = {
  bg: "bg-zinc-950",
  bgSecondary: "bg-zinc-900",
  text: "text-white",
  textMuted: "text-zinc-500",
  textSecondary: "text-zinc-400",
  sectionBg: "md:bg-zinc-900",
  sectionBorder: "md:border md:border-zinc-800",
  card: "bg-zinc-900 border-zinc-800",
  cardHover: "hover:border-zinc-700 hover:bg-zinc-800/50",
  cardBorder: "border border-zinc-800",
  bgAccent: "bg-white",
  buttonPrimary: "bg-white hover:bg-neutral-200",
  buttonPrimaryText: "text-black",
  buttonSecondary: "bg-zinc-900 hover:bg-zinc-800",
  buttonSecondaryText: "text-white",
  inputBg: "bg-transparent",
  inputText: "text-white",
  inputPlaceholder: "placeholder:text-zinc-600",
  selectOption: "bg-zinc-900 text-white",
  border: "border-zinc-800",
  borderSubtle: "border-zinc-800",
  errorBg: "bg-red-500/10",
  errorText: "text-red-400",
  accentBg: "bg-zinc-800",
  accentText: "text-white",
  iconBg: "bg-black",
  iconText: "text-white",
  badge: "bg-white/5 border border-white/10 text-zinc-400",
  // Legacy tokens
  badgePending: "bg-zinc-900/50 text-zinc-400 border-zinc-800",
};

const LIGHT_THEME: ThemeColors = {
  bg: "bg-gray-50",
  bgSecondary: "bg-white",
  text: "text-gray-900",
  textMuted: "text-gray-500",
  textSecondary: "text-gray-600",
  sectionBg: "md:bg-white",
  sectionBorder: "md:border md:border-gray-200",
  card: "bg-white border-gray-200",
  cardHover: "hover:border-gray-300 hover:bg-gray-50/50",
  cardBorder: "border border-gray-200",
  bgAccent: "bg-gray-900",
  buttonPrimary: "bg-gray-900 hover:bg-gray-800",
  buttonPrimaryText: "text-white",
  buttonSecondary: "bg-white hover:bg-gray-50",
  buttonSecondaryText: "text-gray-900",
  inputBg: "bg-transparent",
  inputText: "text-gray-900",
  inputPlaceholder: "placeholder:text-gray-400",
  selectOption: "bg-white text-gray-900",
  border: "border-gray-200",
  borderSubtle: "border-gray-200",
  errorBg: "bg-red-50",
  errorText: "text-red-500",
  accentBg: "bg-gray-100",
  accentText: "text-gray-900",
  iconBg: "bg-gray-900",
  iconText: "text-white",
  badge: "bg-black/5 border border-black/10 text-gray-600",
  // Legacy tokens
  badgePending: "bg-gray-100 text-gray-600 border-gray-200",
};

export function getThemeColors(isDark: boolean): ThemeColors {
  return isDark ? DARK_THEME : LIGHT_THEME;
}
